import * as React from "react";
import { Link } from "react-router-dom";

interface AuthLinkProps {
  text?: string;
  linkText: string;
  to: string;
  className?: string;
}

export const AuthLink: React.FC<AuthLinkProps> = ({
  text,
  linkText,
  to,
  className,
}) => {
  return (
    <div className={className}>
      {text && <span className="text-sm text-700">{text}</span>}
      <Link
        to={to}
        className="font-medium text-sm no-underline text-blue-300 cursor-pointer hover:underline"
      >
        {linkText}
      </Link>
    </div>
  );
};

export default AuthLink;
